module.exports = __webpack_public_path__ + "img/odt.76fefba6.png";